import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { HeaderContainer, SectionTitle } from '@components/Song/shared';

export const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
  width: '100%',
  overflowX: 'hidden',
  gap: 24,
});

export const Header = styled('div', {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
});

export const AudienceContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  overflow: 'visible',
  marginTop: 24,
});

export const TabsSection = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  marginTop: 16,
});

export const AudienceHeader = ({ children }: { children?: React.ReactNode }) => {
  return (
    <HeaderContainer>
      <Header>
        <SectionTitle title="Audience" />
      </Header>
      {children}
    </HeaderContainer>
  );
};
